import { render, staticRenderFns } from "./VesselMonitoringSingleBay.vue?vue&type=template&id=568dcc9c&scoped=true"
import script from "./VesselMonitoringSingleBay.vue?vue&type=script&lang=ts"
export * from "./VesselMonitoringSingleBay.vue?vue&type=script&lang=ts"
import style0 from "./VesselMonitoringSingleBay.vue?vue&type=style&index=0&id=568dcc9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568dcc9c",
  null
  
)

export default component.exports